import { setOptions, importLibrary } from '@googlemaps/js-api-loader';

let configured = false;

function ensureConfigured(): void {
  if (configured) return;
  const key = document
    .querySelector<HTMLMetaElement>('meta[name="djir-gmaps-key"]')
    ?.content?.trim();
  if (!key) {
    throw new Error('djir-gmaps-key meta tag is missing or empty');
  }
  setOptions({
    key,
    v: 'weekly',
    language: 'sr-Latn',
    region: 'RS',
  });
  configured = true;
}

export async function loadGmapsLibraries(): Promise<{
  maps: google.maps.MapsLibrary;
  marker: google.maps.MarkerLibrary;
  geometry: google.maps.GeometryLibrary;
}> {
  ensureConfigured();
  const [maps, marker, geometry] = await Promise.all([
    importLibrary('maps'),
    importLibrary('marker'),
    importLibrary('geometry'),
  ]);
  return { maps, marker, geometry };
}

// Loaded on demand by the start-point autocomplete (Places API New).
export async function loadPlacesLibrary(): Promise<google.maps.PlacesLibrary> {
  ensureConfigured();
  return importLibrary('places');
}
